import React from 'react';
import { useParams, useHistory } from 'react-router-dom';
import { Box, Typography, Grid, Card, CardActionArea, useTheme } from '@mui/material';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTicketAlt, faQrcode } from '@fortawesome/free-solid-svg-icons';

export default function WorkspaceDashboard() {
    const { uuid } = useParams();
    const history = useHistory();
    const theme = useTheme();

    return (
        <Box sx={{ p: 4, maxWidth: 1000, margin: '0 auto' }}>
            <Typography variant="h4" fontWeight="bold" gutterBottom>
                Módulos de Trabajo
            </Typography>
            <Typography variant="body1" color="text.secondary" mb={4}>
                Selecciona la herramienta que vas a utilizar.
            </Typography>

            <Grid container spacing={3}>
                {/* Módulo: TAQUILLA */}
                <Grid item xs={12} sm={6} md={4}>
                    <Card elevation={2} sx={{ borderRadius: '12px' }}>
                        <CardActionArea 
                            onClick={() => history.push(`/workspaces/${uuid}/events`)} 
                            sx={{ p: 4, textAlign: 'center' }}
                        >
                            <FontAwesomeIcon icon={faTicketAlt} style={{ fontSize: '40px', color: theme.palette.primary.main, marginBottom: '16px' }} />
                            <Typography variant="h6" fontWeight="bold">Taquilla (POS)</Typography>
                            <Typography variant="body2" color="text.secondary">Emisión y cobro de boletos</Typography>
                        </CardActionArea>
                    </Card>
                </Grid>

                {/* Módulo: ESCÁNER (Futuro) */}
                <Grid item xs={12} sm={6} md={4}>
                    <Card elevation={0} sx={{ borderRadius: '12px', border: '1px dashed #ccc', opacity: 0.6 }}>
                        <CardActionArea disabled sx={{ p: 4, textAlign: 'center' }}>
                            <FontAwesomeIcon icon={faQrcode} style={{ fontSize: '40px', color: '#999', marginBottom: '16px' }} />
                            <Typography variant="h6" fontWeight="bold">Control de Acceso</Typography>
                            <Typography variant="body2" color="text.secondary">Próximamente...</Typography>
                        </CardActionArea>
                    </Card>
                </Grid>
            </Grid>
        </Box>
    );
}